import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiArrowRight } from 'react-icons/fi';
import { FaFacebook, FaLinkedin, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import api from '../../utils/api';
import { services } from '../../utils/servicesData';

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get('/settings').then(r => setS(r.data)).catch(() => {}); }, []);

  const socialLinks = [
    s.facebook  && [FaFacebook,  s.facebook],
    s.linkedin  && [FaLinkedin,  s.linkedin],
    s.twitter   && [FaTwitter,   s.twitter],
    s.instagram && [FaInstagram, s.instagram],
    s.youtube   && [FaYoutube,   s.youtube],
  ].filter(Boolean);

  return (
    <footer style={{ background: 'var(--navy-dark)', color: 'rgba(255,255,255,0.65)', fontFamily: 'var(--font-sans)' }}>

      {/* ── Top accent bar ── */}
      <div style={{ height: 3, background: 'linear-gradient(90deg, var(--navy-dark), var(--gold), var(--gold-light), var(--gold), var(--navy-dark))' }} />

      {/* ── Main footer grid ── */}
      <div className="container" style={{ padding: '4.5rem 2rem 0' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.8fr 1fr 1fr 1.3fr', gap: '3rem', paddingBottom: '3.5rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
          className="footer-grid">

          {/* Brand column */}
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', marginBottom: '1.25rem' }}>
              <img src="/logo.png" alt="SQS Logo"
                style={{ width: 40, height: 40, objectFit: 'contain' }}
                onError={e => e.target.style.display = 'none'} />
              <div>
                <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 800, color: 'var(--white)', fontSize: '1rem', lineHeight: 1.1, letterSpacing: '-0.01em' }}>
                  Smart Quality Systems
                </div>
                <div style={{ fontSize: '0.6rem', color: 'var(--gold-light)', letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 600, marginTop: 2 }}>
                  Food Safety Consulting
                </div>
              </div>
            </Link>

            <p style={{ fontSize: '0.875rem', lineHeight: 1.8, marginBottom: '1.75rem', color: 'rgba(255,255,255,0.5)', maxWidth: 300 }}>
              {s.tagline || "Ghana's premier food safety and regulatory consulting firm — helping food businesses achieve compliance, build trust, and grow with confidence."}
            </p>

            {/* Social icons */}
            {socialLinks.length > 0 && (
              <div style={{ display: 'flex', gap: '0.6rem', flexWrap: 'wrap' }}>
                {socialLinks.map(([Icon, href], i) => (
                  <a key={i} href={href} target="_blank" rel="noreferrer"
                    style={{
                      width: 36, height: 36, background: 'rgba(255,255,255,0.06)',
                      borderRadius: 'var(--radius-md)', display: 'flex', alignItems: 'center',
                      justifyContent: 'center', color: 'rgba(255,255,255,0.5)',
                      fontSize: '0.9rem', transition: 'var(--transition)', textDecoration: 'none',
                      border: '1px solid rgba(255,255,255,0.08)',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(184,146,42,0.2)'; e.currentTarget.style.color = 'var(--gold-light)'; e.currentTarget.style.borderColor = 'rgba(201,168,76,0.3)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}>
                    <Icon />
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold-light)', marginBottom: '1.25rem' }}>
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {[['/', 'Home'], ['/about', 'About Us'], ['/services', 'Our Services'], ['/projects', 'Portfolio'], ['/book-service', 'Book a Service'], ['/contact', 'Contact']].map(([to, label]) => (
                <li key={to}>
                  <Link to={to}
                    style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'var(--transition)', display: 'flex', alignItems: 'center', gap: '0.35rem' }}
                    onMouseEnter={e => { e.currentTarget.style.color = 'var(--gold-light)'; e.currentTarget.style.paddingLeft = '4px'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; e.currentTarget.style.paddingLeft = '0'; }}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold-light)', marginBottom: '1.25rem' }}>
              Our Services
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
              {services.slice(0, 6).map(sv => (
                <li key={sv.id}>
                  <Link to={`/services/${sv.id}`}
                    style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'var(--transition)', display: 'flex', alignItems: 'center', gap: '0.35rem' }}
                    onMouseEnter={e => { e.currentTarget.style.color = 'var(--gold-light)'; e.currentTarget.style.paddingLeft = '4px'; }}
                    onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; e.currentTarget.style.paddingLeft = '0'; }}>
                    {sv.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--gold-light)', marginBottom: '1.25rem' }}>
              Get In Touch
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.75rem' }}>
              {[
                [FiPhone, s.phone || '+233 24 602 1518', s.phone ? `tel:${s.phone}` : null],
                [FiMail, s.email || 'info@smartqualitysystems.com', s.email ? `mailto:${s.email}` : null],
                [FiMapPin, s.address || 'Vanguard Assurance Building-Accra, Ghana', null],
              ].map(([Icon, val, href], i) => (
                <div key={i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                  <div style={{ width: 32, height: 32, background: 'rgba(184,146,42,0.15)', borderRadius: 'var(--radius-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, border: '1px solid rgba(201,168,76,0.2)' }}>
                    <Icon style={{ color: 'var(--gold-light)', fontSize: '0.85rem' }} />
                  </div>
                  {href
                    ? <a href={href} style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, textDecoration: 'none', transition: 'var(--transition)' }}
                        onMouseEnter={e => e.target.style.color = 'var(--gold-light)'}
                        onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}>{val}</a>
                    : <span style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5 }}>{val}</span>
                  }
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link to="/book-service"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
                background: 'var(--gold)', color: 'var(--white)',
                padding: '0.65rem 1.25rem', borderRadius: 'var(--radius-sm)',
                fontWeight: 700, fontSize: '0.82rem', textDecoration: 'none',
                border: '2px solid var(--gold)', transition: 'var(--transition)',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#9E7A1E'; e.currentTarget.style.borderColor = '#9E7A1E'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'var(--gold)'; e.currentTarget.style.borderColor = 'var(--gold)'; }}>
              Book a Consultation <FiArrowRight />
            </Link>
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 0', flexWrap: 'wrap', gap: '0.75rem' }}
          className="footer-bottom">
          <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.3)', margin: 0 }}>
            © {new Date().getFullYear()} Smart Quality Systems Ltd. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
            {[['Privacy Policy', '/contact'], ['Terms of Service', '/contact'], ['Admin Portal', '/admin']].map(([label, to]) => (
              <Link key={to} to={to}
                style={{ fontSize: '0.77rem', color: 'rgba(255,255,255,0.25)', textDecoration: 'none', transition: 'var(--transition)' }}
                onMouseEnter={e => e.target.style.color = 'var(--gold-light)'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}>
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width:1024px){
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 2.5rem !important; }
        }
        @media(max-width:640px){
          .footer-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
          .footer-bottom { flex-direction: column; align-items: flex-start; gap: 0.5rem; }
        }
      `}</style>
    </footer>
  );
}